export default "assets/images/icons/linkedin-dcf72e88.svg";